import CreatePostContainer from "./CreatePostContainer";
export default CreatePostContainer;
